import React, { createContext, useContext, ReactNode, useState } from 'react'

type ContextType = {
  dirty: boolean
  setDirty: (step: boolean) => void
}

const FormContext = createContext<ContextType | undefined>(undefined)

interface FormProviderProps {
  children: ReactNode
}

export const FormProvider: React.FC<FormProviderProps> = ({ children }) => {
  const [isDirty, setFormDirty] = useState<boolean>(false)

  return (
    <FormContext.Provider
      value={{
        dirty: isDirty,
        setDirty: setFormDirty
      }}
    >
      {children}
    </FormContext.Provider>
  )
}

export const useFormContext = (): ContextType => {
  const context = useContext(FormContext)
  if (!context) {
    throw new Error('useFormContext must be used within a FormContextProvider')
  }
  return context
}
